import { useSuspenseQuery, useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { ReferralShare } from 'src/shared/schemas/referrals/referral-share'

export const getReferralShareById = (referralShareId: number) => {
  return getRequest<ReferralShare>(`/referral-shares/?id=${referralShareId}`)
}

export const useReferralShareById = (referralShareId: number) => {
  return useSuspenseQuery({
    queryKey: queries.referralShares.detail(referralShareId).queryKey,
    queryFn: () => getReferralShareById(referralShareId),
  })
}

export const useReferralShareByIdForChat = (referralShareId: number) => {
  return useQuery({
    queryKey: queries.referralShares.detail(referralShareId).queryKey,
    queryFn: () => {
      return getReferralShareById(referralShareId)
    },
    enabled: !!referralShareId,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  })
}
